import { NgModule, inject } from '@angular/core';
import { CanMatchFn, RouterModule, Routes } from '@angular/router';
import { UserRole } from '../auth/models/user-roles';
import { AuthService } from '../auth/services/auth.service';
import { AdminLayoutComponent } from './shared/admin-layout/admin-layout.component';
import { systemMetricsRoutes } from '../system-metrics/system-metrics.routes';
import { FeatureFlagService } from '../feature-flag/services/feature-flag.service';
import { FeatureFlag } from '../feature-flag/feature-flag.type';

const canMatchRole = (role: UserRole): CanMatchFn => () => inject(AuthService).userHasRoleAndRoleIsEnabled(role);
const canMatchNewLayout: CanMatchFn = () => {
  const service = inject(FeatureFlagService);
  const allFlags = (service as any).featureFlagsSubject.getValue();
  const hasFlag = service.hasFeatureFlagSet(FeatureFlag.UseNewAdminLayout);
  return hasFlag;
};
const canMatchOldLayout: CanMatchFn = () => {
  const service = inject(FeatureFlagService);
  const allFlags = (service as any).featureFlagsSubject.getValue();
  const hasFlag = service.hasFeatureFlagSet(FeatureFlag.UseNewAdminLayout);
  return !hasFlag;
};

const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    canMatch: [canMatchNewLayout],
    children: [
      // Load module based on role to prevent larger than necessary bundles being downloaded.
      {
        path: '',
        canMatch: [canMatchRole(UserRole.SuperUser)],
        loadChildren: () => import('./super-user/super-user.module').then(m => m.SuperUserModule)
      },
      {
        path: '',
        canMatch: [canMatchRole(UserRole.TenantAdmin)],
        loadChildren: () => import('./tenant-admin/tenant-admin.module').then(m => m.TenantAdminModule)
      },
      {
        path: '',
        canMatch: [canMatchRole(UserRole.LockerBankAdmin)],
        loadChildren: () => import('../v2/pages/locker-bank-admin/v2-locker-bank-admin.module').then(m => m.V2LockerBankAdminModule)
      },
      {
        path: '',
        canMatch: [canMatchRole(UserRole.Installer)],
        loadChildren: () => import('./installer/installer.module').then(m => m.InstallerModule)
      },
      // System Metrics routes
      ...systemMetricsRoutes.map(route => ({
        ...route,
        path: route.path?.replace(/^\//, '') ?? route.path // Remove leading slash to make relative
      })),
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/',
      },
    ]
  },
  {
    path: '',
    canMatch: [canMatchOldLayout],
    children: [
      // Load module based on role to prevent larger than necessary bundles being downloaded.
      {
        path: '',
        canMatch: [canMatchRole(UserRole.SuperUser)],
        loadChildren: () => import('./super-user/super-user.module').then(m => m.SuperUserModule)
      },
      {
        path: '',
        canMatch: [canMatchRole(UserRole.TenantAdmin)],
        loadChildren: () => import('./tenant-admin/tenant-admin.module').then(m => m.TenantAdminModule)
      },
      {
        path: '',
        canMatch: [canMatchRole(UserRole.LockerBankAdmin)],
        loadChildren: () => import('../v2/pages/locker-bank-admin/v2-locker-bank-admin.module').then(m => m.V2LockerBankAdminModule)
      },
      {
        path: '',
        canMatch: [canMatchRole(UserRole.Installer)],
        loadChildren: () => import('./installer/installer.module').then(m => m.InstallerModule)
      },
      // System Metrics routes
      ...systemMetricsRoutes.map(route => ({
        ...route,
        path: route.path?.replace(/^\//, '') ?? route.path // Remove leading slash to make relative
      })),
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/',
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
